<div class="detail-page-card">
    @if (!config.hideHeader) {
        <div class="detail-page-card-title">{{ config.name }}</div>
    }
    <div class="detail-page-card-actions">
        @if (
            (config.allowAdd && !config.hideAddButton) ||
            (config.allowDelete && !config.hideDeleteButton)
        ) {
            <div>
                @if (config.allowAdd && !config.hideAddButton) {
                    <button class="btn btn-raised" (click)="addRow()">
                        <i class="fas fa-plus-circle"></i>
                        <span>{{ 'add' | t }}</span>
                    </button>
                }
                @if (config.allowDelete && !config.hideDeleteButton) {
                    <button
                        class="btn btn-raised red"
                        (click)="deleteRow(activeRow)"
                        [disabled]="!activeRow"
                    >
                        <i class="fas fa-trash"></i>
                        <span>{{ 'delete' | t }}</span>
                    </button>
                }
            </div>
        }
        @if (config.dataMethod && !config.hideRefreshButton) {
            <div>
                <button class="btn btn-raised green" (click)="loadPage()">
                    <i class="fas fa-sync"></i>
                    <span>{{ 'reload' | t }}</span>
                </button>
            </div>
        }
    </div>

    @if (ready) {
        @if (!tableData || tableData.length === 0) {
            <div class="detail-page-card-body padded">
                @if (config.emptyMessage) {
                    <small>{{ config.emptyMessage }}</small>
                } @else {
                    <small>No {{ config.name | lowercase }} available.</small>
                    @if (config.allowAdd) {
                        <small>&nbsp;<b>Click add</b> to create a new one.</small>
                    }
                }
            </div>
        }
        @if (groups && groups.length > 0) {
            <div
                class="detail-page-card-body overflow-auto"
                [ngStyle]="{ maxHeight: config.maxHeight ? config.maxHeight : 'auto' }"
            >
                <table class="table-cerrix rounded hoverable centered striped p-0">
                    <thead>
                        <tr>
                            @for (header of headers; track header) {
                                <th
                                    class="sticky"
                                    [class.text-start]="config.cellConfig[header].alignLeft"
                                >
                                    {{ prettyHeaders[header] }}
                                </th>
                            }
                            @if (
                                config.overviewRowActions && config.overviewRowActions.length > 0
                            ) {
                                <th>
                                    {{ config.overviewRowActionsName }}
                                </th>
                            }
                        </tr>
                    </thead>
                    @for (group of groups; track group) {
                        <tbody>
                            @if (group.cellSummaries.length > 0) {
                                <tr
                                    class="summary-row"
                                    (click)="group.isExpanded = !group.isExpanded"
                                >
                                    @for (
                                        cellS of group.cellSummaries;
                                        track cellS;
                                        let i = $index
                                    ) {
                                        <td
                                            [class.text-start]="
                                                config.cellConfig[cellS.header].alignLeft
                                            "
                                        >
                                            @if (i === 0) {
                                                <i
                                                    class="far fa-{{
                                                        group.isExpanded ? 'minus' : 'plus'
                                                    }}-square group-expander"
                                                ></i>
                                            }
                                            <div>
                                                @if (cellS.color) {
                                                    <div
                                                        [style.background-color]="cellS.color"
                                                        class="color-indicator"
                                                    ></div>
                                                }
                                                <b>{{ cellS.summary }}</b>
                                            </div>
                                        </td>
                                    }
                                    @if (
                                        config.overviewRowActions &&
                                        config.overviewRowActions.length > 0
                                    ) {
                                        <td></td>
                                    }
                                </tr>
                            }
                            @for (row of group.items; track row) {
                                <tr
                                    class="hover-row"
                                    [ngClass]="{
                                        highlighted: activeRow && activeRow[idProp] == row[idProp],
                                    }"
                                    [hidden]="!group.isExpanded"
                                    (click)="triggerClick(row)"
                                    (dblclick)="triggerDblClick(row)"
                                >
                                    @for (header of headers; track header) {
                                        <td
                                            class="text-truncate"
                                            style="max-width: 400px"
                                            [class.text-start]="config.cellConfig[header].alignLeft"
                                        >
                                            <workspace-cell
                                                [configs]="config.rendererConfig"
                                                [row]="row"
                                                [header]="header"
                                                [stretched]="false"
                                            >
                                            </workspace-cell>
                                        </td>
                                    }
                                    @if (
                                        config.overviewRowActions &&
                                        config.overviewRowActions.length > 0
                                    ) {
                                        <td>
                                            @for (
                                                btnConfig of config.overviewRowActions;
                                                track btnConfig
                                            ) {
                                                <i
                                                    [class]="btnConfig.icon + ' ms-2 me-2'"
                                                    [matTooltip]="btnConfig.tooltip"
                                                    (click)="btnConfig.clickEvent(row)"
                                                    [hidden]="
                                                        btnConfig.showProperty &&
                                                        !row[btnConfig.showProperty]
                                                    "
                                                ></i>
                                            }
                                        </td>
                                    }
                                </tr>
                            }
                        </tbody>
                    }
                </table>
            </div>
        }
    } @else {
        <div class="detail-page-card-body padded cerrix-control-sm">
            <div class="fancy-loader submodule"></div>
        </div>
    }
</div>

@if (ready) {
    <generic-form-editor
        [config]="config"
        [additionalData]="additionalData"
        (change)="applyRowChange($event)"
        #editorCmp
    >
    </generic-form-editor>
}
